import {Injectable} from '@angular/core';
import {DataService} from "../../../../services/external-api/data.service";
import {
  emptyDocumentationSection,
  emptyParty,
  emptyPlatformConnectionRequestHeader,
  emptyPlatformConnectionRequestDetail,
  emptyResource,
  emptyRole,
  emptyUser,
  IDocumentationSection,
  IParty,
  IPlatformConnectionRequestHeader,
  IResource,
  IRole,
  IUser,
  IPlatformConnectionRequestDetail,
  IResourceGroup,
  emptyResourceGroup,
  IPartyDocument,
  emptyPartyDocument
} from "@retail-data-factory/rdf-angular-types-api";
import {Observable, throwError} from "rxjs";
import {map} from "rxjs/operators";
import * as moment from "moment";
import {ApiService} from "../../../../services/external-api/api.service";
import {IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {Presenter} from "../../../internal/presenter/presenter";
import { AssistTranslationService } from '@retail-data-factory/rdf-angular-translation-service';

@Injectable({
  providedIn: 'root'
})
export class ApiPlatformService {
  connectionRequest:IPlatformConnectionRequestHeader;
  constructor(private dataService: DataService,
              private presenter: Presenter,
              private apiService: ApiService,
              private configurationManager: ConfigurationManager,
              private atService: AssistTranslationService) {
  }

  createPartnership(party: IParty) {
    const param = {
      partyid: this.presenter.currentPartyId,
      partychildid: party.id
    };
    const body = '';
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/partnership?action=create', param, body);

  }

  removePartnership(party: IParty) {
    const param = {
      partyid: party.id
    };
    const body = '';
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/partnership?action=cancel', param, body);
  }

  blockRelationship(party: IParty) {
    const param = {
      party_id: party.id
    };
    const body = '';
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/partnership?action=block', param, body);

  }

  unBlockRelationship(party: IParty) {
    const param = {
      party_id: party.id
    };
    const body = '';
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/partnership?action=unblock', param, body);
  }


  /**
   * Заблокировать контрагента
   * @param partyId
   */
  blockParty(partyId: string) {
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/parties/${partyId}?action=block`, {}, null);

  }

  /**
   * Разблокировать контрагента
   * @param partyId
   */
  unBlockParty(partyId:string) {
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') +  `/parties/${partyId}?action=unblock`, {}, null);
  }

  resetPartyPassword(party: IParty) {
    const param = {
      login: party.email,
      inn: party.legalId
    };
    const body = '';
    return this.dataService.putData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/resetpassword', param, body);
  }

  changeMasterLogin(party: IParty, newLogin: string) {
    const param = {
      user_id: party.id,
      login: newLogin
    };
    const body = '';
    return this.dataService.putData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/users/login', param, body);
  }

  getParty(partyId: string): Observable<IParty> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/party/${partyId}`, {}).pipe(
      map(result => {
        if (result.report.length > 0) {
          return this.mapPartyFromService(result.report[0]);
        } else {
          return JSON.parse(JSON.stringify(emptyParty));
        }
      })
    );
  }

  getPartyList(search = ''): Observable<Array<IParty>> {
    const url = search ? `${this.configurationManager.getApiUrl('apiPlatformUrl')}/party?search=${search}` : `${this.configurationManager.getApiUrl('apiPlatformUrl')}/party/`;
    return this.dataService.getReportData(url, {}).pipe(
      map(
        result => {
          return result.report.map(t => this.mapPartyFromService(t));
        }
      )
    );
  }

  /**
   * Получение списка контрагентов
   * @param relationType - тип контрагента, merch_client - Клиент, crowd_worker - Подработчик
   * @param direction - направление связи
   */
  getCounterparty(relationType: 'merch_client' | 'crowd_worker', direction: 'parent' | 'child'): Observable<Array<IParty>> {
    const param = {
      relation_type: relationType,
      direction: direction
    }
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/counterparty`, param).pipe(
      map(
        result => {
          return result.report.map(t => this.mapPartyFromService(t));
        }
      )
    );
  }

  getSubdivisions(): Observable<Array<IParty>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/parties/subdivisions`, {}).pipe(
      map(
        result => {
          return result.report.map(t => this.mapPartyFromService(t));
        }
      )
    );
  }
  updateParty(party: IParty):Observable<IServiceResponse>{
    const body = this.mapPartyToService(party);
    const header = {
      legalid: party.legalId
    };

    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/parties/${party.id}`,header,body);
  }
  createParty(party: IParty):Observable<IServiceResponse>{
    const param = {
      legalid: party.legalId
    };
    const body = this.mapPartyToService(party);
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/parties', param, body);
  }

  createSubdivision(party: IParty):Observable<IServiceResponse>{
    const param = {
    };
    const body =
      {
        "LegalName":party.name,
        "ShortName": party.shortName,
        "LegalID": '',
        "PartnerType": party.typeCode,
        "LegalAddress": party.legalAddress,
        "KPP": '',
        "OGRN": '',
        "OKPO": '',
        "AcccountNo": '',
        "KorrAccountNo": '',
        "BankName": '',
        "BankBik": ''
      };
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/parties/subdivisions', param, body);
  }

  getAuthenticatedUserProfile(accessToken: string) {
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/users/token', {
      'access_token': accessToken
    });

  }

  getPartyProfile(accessToken: string) {
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/mypartyinformation', {
      'access_token': accessToken
    });
  }

  getPartnersOld(accessToken?: string) {
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/party', {
      'access_token': accessToken
    });
  }

  getPartyResources(partyId: string): Observable<Array<IResource>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/party/${partyId}/resources`, {}).pipe(
      map(result => {
        return result.report.map(t => this.mapResourceFromService(t));
      })
    );
  }


  getPartyRelationshipAttribute(accessToken: string, parentPartyId: string, childPartyId: string, attributeCode: string) {
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/party/relationship/attribute/' + attributeCode, {
      'access_token': accessToken,
      'partyid': parentPartyId,
      'partychildid': childPartyId
    });

  }

  getResources(accessToken: string) {
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/resource', {
      'access_token': accessToken
    });
  }

  getPlatformResources(selectAllResources: boolean = false): Observable<Array<IResource>> {
    if (selectAllResources) {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/resource?search=all`, {}).pipe(
        map(result => {
          return result.report.map(t => this.mapResourceFromService(t));
        })
      );
    } else {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/resource`, {}).pipe(
        map(result => {
          return result.report.map(t => this.mapResourceFromService(t));
        })
      );

    }
  }

  getPlatformResource(resourceId: string): Observable<IResource> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/admin/resources/${resourceId}`, {}).pipe(
      map(result => {
        return result.report.length ? this.mapAdminResourceFromService(result.report[0]) : {...emptyResource};
      })
    );
  }

  createPlatformResource(resource: IResource): Observable<IServiceResponse> {
    const param = {};
    const body = {
      "app_id": resource.groupId,
      "name": resource.name,
      "function_code": resource.code,
      "function_type": resource.type,
      "description": resource.description,
      "ord_no": resource.orderNo ? resource.orderNo : '0',
      "profile": resource.profile
    };
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/admin/resources', param, body);
  }


  getPlatformApplications(selectAllApplications = false): Observable<Array<IResourceGroup>> {
    if (selectAllApplications) {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/admin/applications?search=all`, {}).pipe(
        map(result => {
          return result.report.map(t => this.mapResourceGroupFromService(t));
        })
      );
    } else {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/admin/applications`, {}).pipe(
        map(result => {
          return result.report.map(t => this.mapResourceGroupFromService(t));
        })
      );

    }

  }

  getPlatformApplication(resourceGroupId: string): Observable<IResourceGroup> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/admin/applications/${resourceGroupId}`, {}).pipe(
      map(result => {
        if (result.report.length) {
          return this.mapResourceGroupFromService(result.report[0]);
        } else {
          return {...emptyResourceGroup, resources:[]};
        }
      })
    );

  }
  savePlatformApplication(resourceGroup: IResourceGroup): Observable<IServiceResponse> {
    return resourceGroup.id?this.updatePlatformApplication(resourceGroup): this.createPlatformApplication(resourceGroup);
  }

  createPlatformApplication(resourceGroup: IResourceGroup): Observable<IServiceResponse> {
    const param = {};
    const body =
      {
        "name": resourceGroup.name,
        "description": resourceGroup.description,
        "app_code": resourceGroup.code,
        "app_icon": resourceGroup.img,
        "app_name": resourceGroup.name,
        "host_url": '',
        "app_url": resourceGroup.url,
        "app_platform": resourceGroup.platform,
        "order_no": resourceGroup.orderNo,
        "profile": resourceGroup.profile
      };

    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/admin/applications/`,param,body);
  }
  updatePlatformApplication(resourceGroup: IResourceGroup): Observable<IServiceResponse> {
    const param = {};
    const body =
      {
        "name": resourceGroup.name,
        "description": resourceGroup.description,
        "app_code": resourceGroup.code,
        "app_icon": resourceGroup.img,
        "app_name": resourceGroup.name,
        "host_url": '',
        "app_url": resourceGroup.url,
        "app_platform": resourceGroup.platform,
        "order_no": resourceGroup.orderNo,
        "profile": resourceGroup.profile
      };
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/admin/applications/${resourceGroup.id}`,param,body);
  }


  getUserResources(userId: string): Observable<Array<IResource>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/${userId}/resources`, {}).pipe(
      map(result => {
        return result.report.map(t => this.mapResourceFromService(t));
      })
    );

  }

  resetPassword(inn: string, email: string) {
    const requestParameters = {};
    requestParameters['login'] = email;
    requestParameters['inn'] = inn;

    const body = '';

    return this.dataService.putData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/resetpassword', requestParameters, body);
  }
  blockUser(userId: string):Observable<IServiceResponse> {
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/users/${userId}?action=block`, {}, null);

  }
  unBlockUser(userId: string):Observable<IServiceResponse> {
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/users/${userId}?action=unblock`, {}, null);
  }

  /**
   * Получение списка пользователей для пати.
   * @param partyId - ID party, для которой запрашщивается список пользователей.  Если пати не указан, то будет возвращен список пользователй своей пати
   */
  getUsers(partyId = this.presenter.currentPartyId): Observable<Array<IUser>> {
    const url = this.configurationManager.theme === 'auchan'?
      `${this.configurationManager.getApiUrl('apiPlatformUrl')}/users`:
      `${this.configurationManager.getApiUrl('apiPlatformUrl')}/parties/${partyId}/users`;
    const header = partyId?{'party_id':partyId}:{};
    return this.dataService.getReportData(url, header).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(user => this.mapUserFromService(user));
      })
    );
  }

  getUser(id: string): Observable<IUser> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/${id}`, {}).pipe(
      map((result: IServiceResponse)=> {
        if (result.report.length) {
          const item = result.report[0];
          const user: IUser = this.mapUserFromService(item);
          return user;
        } else {
          return {...emptyUser};
        }
      })
    );
  }
  getPartyUsers(): Observable<Array<IUser>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users`, {}, [], true).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(user => this.mapUserFromService(user));
      })
    );
  }

  getAvailableUsers(): Observable<Array<IUser>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users?search=available`, {}, [], true).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(user => this.mapUserFromService(user));
      })
    );
  }

  createUser(user: IUser, partyId?: string, sendEmail:boolean=true): Observable<IServiceResponse> {
    const param = {
      partyid: partyId,
      login: user.login?user.login: user.email,
      email: user.email
    };
    const body = {
      "FirstName": user.firstName,
      "LastName": user.lastName,
      "job_title": user.position,
      "department": user.department,
      "Phone1": user.phone,
      "Phone2": "",
      "delivery_site_id": ""
    };
    const url = this.configurationManager.getApiUrl('apiPlatformUrl') + `/users?send=${sendEmail}`;
    return this.dataService.postData(url, param, body);
  }


  /**
   * Получить список CrowdWorker
   */
  getCrowdWorkers():Observable<Array<IUser>> {

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/crowd`, {}, [], true).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(user => this.mapCrowdWorkerFromService(user));
      })
    );

  }
  /**
   * Получить  CrowdWorker
   */
  getCrowdWorker(workerId: string):Observable<Array<IUser>> {

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/${workerId}/crowd`, {}, [], true).pipe(
      map((result: IServiceResponse) => {
        return result.report.length>0?this.mapCrowdWorkerFromService(result.report[0]): JSON.parse(JSON.stringify(emptyUser));
      })
    );

  }
  /**
   * Получить все доступные роли
   */
  getRoles(partyId?: string): Observable<Array<IRole>> {
    const param = {
    };
    if(partyId) {
      param['party_id'] = partyId
    }
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/roles`, param, [], true).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(role => this.mapRoleFromService(role));
      })
    );
  }

  /**
   * Получить роль по ID
   * @param roleId ID роли
   */
  getRole(roleId: string): Observable<IRole> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/roles/${roleId}`, {}, [], true).pipe(
      map((result: IServiceResponse) => {
        if (result && result.report && result.report.length) {
          return this.mapRoleFromService(result.report[0]);
        } else {
          return {...emptyRole};
        }
      })
    );
  }

  /**
   * Создать роль
   * @param role
   */
  createRole(role: IRole): Observable<IServiceResponse> {
    const param = {};
    const body = {
      name: role.name,
      code: role.code,
      description: role.description,
      resources: role.resources.map(t => t.id)
    };
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/roles', param, body);
  }

  /**
   * Обновить роль
   * @param role
   */
  updateRole(role: IRole): Observable<IServiceResponse> {
    const param = {};
    const body = {
      name: role.name,
      code: role.code, //Код роли
      description: role.description,
      resources: role.resources.map(t => t.id)
    };
    return this.dataService.putData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/roles/${role.id}`, param, body);

  }

  /**
   * Сохранить роль (создать или обновить в зависимости от role.id)
   * @param role
   */
  saveRole(role: IRole): Observable<IServiceResponse> {
    return role.id?this.updateRole(role):this.createRole(role);
  }

  /**
   * Удалить роль
   * @param roleId ID роли
   */
  deleteRole(roleId: string): Observable<IServiceResponse> {
    return this.dataService.deleteData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/roles/${roleId}`, {}, null);
  }


  /**
   * Получение списка ролей, присвоенных пользователю
   * @param userId - ID пользователя
   */
  getUserRoles(userId: string, partyId?: string): Observable<Array<IRole>> {
    const param = {
    };
    if(partyId) {
      param['party_id'] = partyId
    }
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/${userId}/roles`, param, [], true).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(role => this.mapRoleFromService(role));
      })
    );
  }

  /**
   * Получение списка ролей, присвоенных текущему пользователю
   * @param userId - ID пользователя
   */
  getCurrentUserRoles(): Observable<Array<IRole>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/${this.presenter.authenticatedUserState.data.id}/roles`, {}, [], true).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(role => this.mapRoleFromService(role));
      })
    );
  }

  /**
   * Установка списка ролей пользователю
   * @param userId - ID пользователя
   * @param roles - массив ролей IRole
   */
  setUserRoles(userId: string, roles: Array<IRole>): Observable<IServiceResponse> {
    const body = {
      roles: roles.map(t => t.id)
    };
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/users/${userId}/roles`, {}, body);
  }


  getDocumentations(): Observable<Array<IDocumentationSection>> {
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/documentations', {}).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(section => this.mapDocumentationSectionFromService(section));
      })
    );
  }


  getConnectionRequests(dateFrom: Date, dateTo: Date): Observable<Array<IPlatformConnectionRequestHeader>> {
    const header = {
      date_from: moment(dateFrom).format('YYYYMMDD'),
      date_until: moment(dateTo).format('YYYYMMDD'),
    };
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + '/platformrequests', header).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(t => this.mapConnectionRequestFromService(t));
      })
    );
  }

  getConnectionRequest(requestId: string): Observable<IPlatformConnectionRequestHeader> {

    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/platformrequests/${requestId}`, {}).pipe(
      map((result: IServiceResponse) => {
        if (result.report.length) {
          return this.mapConnectionRequestFromService(result.report[0]);
        } else {
          return this.emptyConnectionRequestHeader;
        }
      })
    );
  }

  createConnectionRequest(request: IPlatformConnectionRequestHeader): Observable<IServiceResponse> {
    const body = this.mapConnectionRequestToService(request);
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/platformrequests`, {}, body);
  }

  updateConnectionRequest(request: IPlatformConnectionRequestHeader): Observable<IServiceResponse> {
    const body = this.mapConnectionRequestToService(request);
    return this.dataService.putData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/platformrequests/${request.id}`, {}, body);
  }

  saveConnectionRequest(request: IPlatformConnectionRequestHeader): Observable<IServiceResponse> {
    return request.id ? this.updateConnectionRequest(request) : this.createConnectionRequest(request);
  }

  approveConnectionRequest(requestId): Observable<IServiceResponse> {
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/platformrequests/${requestId}?action=approve`, {}, {});
  }

  completeConnectionRequest(requestId): Observable<IServiceResponse> {
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/platformrequests/${requestId}?action=complete`, {}, {});
  }
  completeWithErrorConnectionRequest(requestId): Observable<IServiceResponse> {
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/platformrequests/${requestId}?action=complete_with_error`, {}, {});
  }

  rejectConnectionRequest(request: IPlatformConnectionRequestHeader): Observable<IServiceResponse> {
    return this.dataService.postData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/platformrequests/${request.id}?action=reject`, {}, {});
  }


  mapUserFromService(item: object): IUser {
    const user: IUser = {
      ...emptyUser,
      partyId: item['PartyID'] ? item['PartyID'] : '',
      status: item['UserStatus']?item['UserStatus']: 'UNKNOWN',
      id: item['ID'],
      login: item['Login'] ? item['Login'] : '',
      firstName: item['FirstName'] ? item['FirstName'] : '',
      lastName: item['LastName'] ? item['LastName'] : '',
      phone: item['phone'] ? item['phone'] : item['profile'] && item['profile']['Phone1']? item['profile']['Phone1']:'',
      email: item['Email'] ? item['Email'] : '',
      type: item['TypeUser'],
      department: item['profile'] && item['profile']['department']? item['profile']['department']:'',
      position: item['profile'] && item['profile']['job_title']? item['profile']['job_title']:'',
      deliverySiteId: item['profile'] && item['profile']['delivery_site_id']? item['profile']['delivery_site_id']:'',
      image: '',
      profile: JSON.parse(JSON.stringify({
        ...emptyUser,
        ...item['profile']
      }))

    };
    user.userName = `${user.firstName} ${user.lastName}`;
    return user;
  }


  mapPartyFromService(item: object): IParty {
    const party: IParty = {
      ...emptyParty,
      id: item['ID'],
      legalId: item['LegalID'],
      typeCode: item['TypeCode'],
      statusCode: item['StatusCode'],
      vatTypeCode: item['profile'] && item['profile']['VatTypeCode']?item['profile']['VatTypeCode']:'',

      name: item['Name']?item['Name']:
        item['profile'] && item['profile']['LegalName']?item['profile']['LegalName']:'',

      shortName: item['profile'] && item['profile']['ShortName']?item['profile']['ShortName']:'',
      legalTypeCode: item['profile'] && item['profile']['LegalTypeCode']?item['profile']['LegalTypeCode']:'',
      legalAddress: item['LegalAddress']?item['LegalAddress']:
        item['profile'] && item['profile']['LegalAddress']?item['profile']['LegalAddress']:'',
      postAddress: item['profile'] && item['profile']['PostAddress']?item['profile']['PostAddress']:'',
      city: item['City']?item['City']:
        item['profile'] && item['profile']['City']?item['profile']['City']:'',

      kpp: item['Kpp']?item['Kpp']:
        item['profile'] && item['profile']['KPP']?item['profile']['KPP']:'',
      ogrn: item['profile'] && item['profile']['OGRN']?item['profile']['OGRN']: '',
      ogrnIssueDate: item['profile'] && item['profile']['OGRN']?moment(item['profile']['OGRN'],'YYYYMMDD').toDate(): null,
      okpo: item['profile'] && item['profile']['OKPO']?item['profile']['OKPO']: '',
      okonh: item['profile'] && item['profile']['OKONH']?item['profile']['OKONH']: '',


      phone: item['profile'] && item['profile']['phone']?item['profile']['phone']: '',
      email: item['profile'] && item['profile']['email'] ? item['profile']['email'] : item['email'],

      accountNo: item['profile'] && item['profile']['AccountNo']?item['profile']['AccountNo']: '',
      corrAccountNo: item['profile'] && item['profile']['KorrAccountNo']?item['profile']['KorrAccountNo']: '',
      bik: item['profile'] && item['profile']['BankBik']?item['profile']['BankBik']: '',
      bankName: item['profile'] && item['profile']['BankName']?item['profile']['BankName']: '',
      accountManager: item['profile'] && item['profile']['AccountManager']?item['profile']['AccountManager']: '',


      contactName: item['profile'] && item['profile']['ContactName']?item['profile']['ContactName']: '',
      contactEmail: item['profile'] && item['profile']['ContactPhone']?item['profile']['ContactPhone']: '',
      contactPhone: item['profile'] && item['profile']['ContactEmail']?item['profile']['ContactEmail']: '',


      parentRelationshipStatus: item['ParentRelationshipStatus'],
      childRelationshipStatus: item['ChildRelationshipStatus'],
      dateCreate: item['Created Date'] ? moment(item['Created Date'], 'DD.MM.YYYY').toDate() : null,
      profile: item['profile']
    };



    return party;
  }
  mapPartyToService(party: IParty):object {
    const result =
      {
        ...party.profile,
        "LegalTypeCode": party.legalTypeCode,
        "LegalName":party.name,
        "ShortName": party.shortName,
        "LegalID": party.legalId,
        "PartnerType": party.typeCode,
        "LegalAddress": party.legalAddress,
        "PostAddress": party.postAddress,
        "City": party.city,

        "KPP": party.kpp,
        "OGRN": party.ogrn,
        "OKPO": party.okpo,
        "OKONH": party.okonh,
        "OGRN_issueDate": moment(party.ogrnIssueDate).format('YYYYMMDD'),

        "VatTypeCode": party.vatTypeCode,

        "AcccountNo": party.accountNo,
        "KorrAccountNo": party.corrAccountNo,
        "BankName": party.bankName,
        "BankBik": party.bik,
        "AccountManager": party.accountManager,
        "email": party.email,
        "phone": party.phone,
        "ContactName": party.contactName,
        "ContactPhone": party.contactPhone,
        "ContactEmail": party.contactEmail
      };
    return result;
  }

  mapResourceFromService(item: object): IResource {
    const result: IResource = {
      ...emptyResource,
      id: item['Resource ID'].toString(),
      code: item['Resource Code'] ? item['Resource Code'] : '',
      name: item['Resource Name'] ? item['Resource Name'] : '',
      description: item['Resource Description'] ? item['Resource Description'] : '',
      isTransferable: item['is_transferable'] === 1 || item['is_transferable'] === '1',
      url: item['Application URL'] ? item['Application URL'] : '',
      img: item['Resource Icon'] ? item['Resource Icon'] : '',
      type: item['Resource Type'] ? item['Resource Type'] : '',


      groupId: item['Application ID'],
      groupCode: item['Application Code'],
      groupName: item['Application Name'],
      groupDescription: item['Application Description'],
      profile: item['resource_profile'],
      resourceGroupProfile: item['app_profile']
    };
    return result;
  }

  mapAdminResourceFromService(item: object): IResource {
    const result: IResource = {
      ...emptyResource,
      id: item['resource_id'].toString(),
      code: item['resource_code'] ? item['resource_code'] : '',
      name: item['resource_name'] ? item['resource_name'] : '',
      description: item['resource_description'] ? item['resource_description'] : '',
      url: item['profile'] ? item['profile']['url'] : '',
//      url: item['Application URL'] ? item['Application URL'] : '',
      type: item['resource_type'] ? item['resource_type'] : '',
      orderNo: item['order_no'] !== null && item['order_no'] !== undefined ? item['order_no'].toString() : '',
      groupId: item['app_id'] !== null && item['app_id'] !== undefined ? item['app_id'].toString() : '',
      profile: item['profile']
    };
    return result;
  }


  mapResourceGroupFromService(item: object): IResourceGroup {

    const result: IResourceGroup = {
      ...emptyResourceGroup,
      id: item['app_id'].toString(),
      code: item['app_code'] ? item['app_code'] : '',
      name: item['app_name'] ? item['app_name'] : '',
      description: item['app_description'] ? item['app_description'] : '',
      img: item['app_icon'] ? item['app_icon'] : '',
      url: item['app_url'] ? item['app_url'] : '',
      ownerPartyId: item['id_party_owner'] !== null && item['id_party_owner'] !== undefined ? item['id_party_owner'].toString() : '',
      platform: item['app_platform_code'] ? item['app_platform_code'] : '',
      orderNo: item['order_no'],
      profile: item['profile'] ? item['profile'] : {},
      resources: []
    };


    return result;
  }

  mapRoleFromService(item: object): IRole {
    const result: IRole = {
      ...emptyRole,
      id: item['id'].toString(),
      name: item['role_name'] ? item['role_name'] : '',
      description: item['role_description'] ? item['role_description'] : '',
      idUserCreate: item['user_id_created']!==null && item['user_id_created']!==undefined?item['user_id_created'].toString(): '',
      idUserUpdate: item['user_id_update']!==null && item['user_id_update']!==undefined?item['user_id_update'].toString(): '',
      loginUserCreate: item['login_create'] ? item['login_create'] : '',
      loginUserUpdate: item['login_update'] ? item['login_update'] : '',
      nameUserCreate: item['username_create'] ? item['username_create'] : '',
      nameUserUpdate: item['username_update'] ? item['username_update'] : '',
      dateCreate: item['date_create']?moment(item['date_create'],'YYYYMMDD HH:mm:ss').toDate():null,
      dateUpdate: item['date_update']?moment(item['date_update'],'YYYYMMDD HH:mm:ss').toDate():null,
      resources: item['resources'] && Array.isArray(item['resources']) && item['resources'].length ? item['resources']
        .filter(t=>t['Resource ID'] !== null && t['Resource ID'] !== undefined)
        .map(t => this.mapResourceFromService(t)) : []
    };
    return result;
  }

  mapDocumentationSectionFromService(item: object): IDocumentationSection {
    const section: IDocumentationSection = {
      ...emptyDocumentationSection,
      ...item['profile']
    };
    return section;
  }

  mapConnectionRequestFromService(item: object): IPlatformConnectionRequestHeader {
    const result: IPlatformConnectionRequestHeader = {
      ...this.emptyConnectionRequestHeader,
      id: item['id'].toString(),
      dateCreate: moment(item['create_date'], 'YYYYMMDD HH:mm:ss').toDate(),
      statusCode: item['status_code'],
      parentPartyId: item['parent_party_id'] !== null && item['parent_party_id'] ? item['parent_party_id'].toString() : '',
      userId: item['create_user_id'] !== null && item['create_user_id'] ? item['create_user_id'].toString() : '',
      confirmationCode: item['confirmation_code'] !== null && item['confirmation_code'] ? item['confirmation_code'].toString() : '',
      sourceTypeCode: item['profile'] ? item['profile']['source_type_code'] : 'unknown',
      typeCode: item['profile'] ? item['profile']['type_code'] : 'unknown',
      brandCode:item['profile'] ? item['profile']['brand_code'] : 'redfactory',
      name: item['profile'] ? item['profile']['name'] : '',
      distributorPartyId: item['profile'] ? item['profile']['distributor_party_id'] : '',
      distributorPartyName: item['profile'] ? item['profile']['distributor_party_name'] : '',

      details: []
    };
    if (item['profile'] && item['profile']['details'] && Array.isArray(item['profile']['details'])) {
      item['profile']['details'].forEach(t => {
        result.details.push(
          {
            ...this.emptyConnectionRequestDetail,
            ...t
          }
        );
      });
    }
    return result;
  }

  mapConnectionRequestToService(request: IPlatformConnectionRequestHeader): object {
    const result = {
      name: request.name,
      distributor_party_id: request.distributorPartyId,
      distributor_party_name: request.distributorPartyName,
      source_type_code: request.sourceTypeCode,
      type_code: request.typeCode,
      brand_code: request.brandCode,
      details: request.details
    };
    return result;
  }

  get emptyConnectionRequestHeader(): IPlatformConnectionRequestHeader {
    const result =  JSON.parse(JSON.stringify(emptyPlatformConnectionRequestHeader));
    return result;
  }

  get emptyConnectionRequestDetail(): IPlatformConnectionRequestDetail {
    const result =  JSON.parse(JSON.stringify(emptyPlatformConnectionRequestDetail));
    return result;
  }

  /**
   * Получение названия типа источника заявки по коду типа источника
   * @param request
   */

  decodeConnectionRequestSourceTypeName(request: IPlatformConnectionRequestHeader): string {
    switch (request.sourceTypeCode) {
      case 'manual':
        return 'Введена вручную';
      case 'site':
        return 'Портал redfactory.io';
      case 'ism':
        return 'Сервис ISellMore';
      default:
        return 'Не определен';

    }
  }

  /**
   * Получение цвета статуса заявки на подключение по коду статуса
   * @param request
   */
  decodeStatusColor(request: IPlatformConnectionRequestHeader): string {
    switch (request.statusCode) {
      case 'INITIAL':
        return 'blue';
      case 'APPROVED':
        return 'green';
      case 'CANCELED':
        return 'red';
      case 'REJECTED':
        return 'red';
      case 'PROCESSING':
        return 'green';
      case 'PRECESSED_WITH_ERRORS':
        return 'red';
      case 'COMPLETED_WITH_ERROR':
        return 'red';
      case 'COMPLETED':
        return 'green';
      default:
        return 'gray';
    }
  }

  /**
   * Получение названия статуса заявки на подключение по коду статуса
   * @param request
   */
  decodeStatusName(request: IPlatformConnectionRequestHeader): string {
    switch (request.statusCode) {
      case 'INITIAL':
        return 'Новая';
      case 'APPROVED':
        return 'Подтверждена';
      case 'CANCELED':
        return 'Отменена';
      case 'REJECTED':
        return 'Отклонена';
      case 'PROCESSING':
        return 'В обработке';
      case 'PRECESSED_WITH_ERRORS':
        return 'Обработана с ошибками';
      case 'COMPLETED_WITH_ERROR':
        return 'Обработана с ошибками';
      case 'COMPLETED':
        return 'Обработана успешно';
      default:
        return 'Не определено';
    }

  }
  decodePartyTypeName(typeCode: string): string {
    switch (typeCode) {
      case 'SUPPLIER':
        return 'Поставщик';
      case 'RETAILER':
        return 'Ритейлер';
      case 'DISTRIBUTOR':
        return 'Дистрибьютор';
      case 'PLATFORM':
        return 'Платформа';
      case 'VENDOR':
        return 'Производитель';
      case 'DATA_PROVIDER':
        return 'Провайдер данных';
      case 'PARTNER':
        return 'Партнер';
      case 'POS':
        return 'Торговая точка';
      default:
        return 'Не определен';
    }
  }
  decodePartyStatusName(statusCode: string): string {
    switch (statusCode) {
      case 'INITIAL':
        return 'Новая';
      case 'ACTIVE':
        return 'Активна';
      case 'BLOCKED':
        return 'Заблокирована';
      default:
        return 'Не определен';
    }
  }
  decodePartyStatusColor(statusCode: string):string {
    switch (statusCode) {
      case 'INITIAL':
        return 'blue';
      case 'ACTIVE':
        return 'green';
      case 'BLOCKED':
        return 'red';
      default:
        return 'gray';
    }


  }
  decodeResourceTypeName(type: string): string {

    const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

    switch (type) {
      case'BUTTON': return  'Кнопка';
      case 'SCREEN': return  capitalize(this.atService.instant('common.screen'));
      case 'REPORT': return  capitalize(this.atService.instant('common.report'));
      case 'FUNCTION': return  'Функция';
      case 'OPERATION': return  'Batch операция ';
      case 'API_FORM': return  'Форма запуска API';
      case 'API_REQUEST': return  'API запрос';
      default: return type;
    }
  }
  decodeUserStatusName(statusCode: string): string {
    switch (statusCode) {
      case 'ACTIVE':
        return 'active';
      case 'BLOCKED':
        return 'blocked';
      default:
        return 'unknownStatus';
    }
  }
  decodeUserStatusColor(statusCode: string): string {
    switch (statusCode) {
      case 'ACTIVE':
        return 'green';
      case 'BLOCKED':
        return 'red';
      default:
        return 'gray';
    }
  }

  mapCrowdWorkerFromService(item: object): IUser {
    const result:IUser = {
      ...JSON.parse(JSON.stringify(emptyUser)),
      partyId: this.nvlString(item['party_id']).toString(),
      status: this.nvlString(item['user_status']),
      id: this.nvlString(item['id']).toString(),
      userName: this.nvlString(item['first_name']) + ' ' + this.nvlString(item['last_name']),
      login: this.nvlString(item['login']),
      firstName: this.nvlString(item['first_name']),
      lastName: this.nvlString(item['last_name']),
      surName: this.nvlString(item['sur_name']),
      phone: this.nvlString(item['phone']),
      email: this.nvlString(item['email']),
      type: this.nvlString(item['user_type_code']),
      department: '',
      position: '',
      deliverySiteId: '',
      image: '',

      isSnilsChecked: false,
      isVatCodeChecked: false,
      isSelfEmployeeStatusChecked: false,
      regionId: item['region_id']?item['region_id'].toString():'',
      regionName:item['region_name']?item['region_name']:'',

      createDate: item['date_registration'] ? moment(item['date_registration'], 'YYYYMMDD HH:mm:ss').toDate() : null,
      updateDate: item['date_update'] ? moment(item['date_update'], 'YYYYMMDD HH:mm:ss').toDate() : null,
      dateFirstWork: item['date_first_work'] ? moment(item['date_first_work'], 'YYYYMMDD HH:mm:ss').toDate() : null,
      dateLastWork: item['date_last_work'] ? moment(item['date_last_work'], 'YYYYMMDD HH:mm:ss').toDate() : null,
      crowdRating: item['crowd_rating']?item['crowd_rating']:0
    }
    return result;
  }
  nvlString(value): string {
    return value?value:''
  }

  getPartyDocuments(partyId: string): Observable<Array<IPartyDocument>> {

    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiPlatformUrl') + `/parties/${partyId}/documents`, {}).pipe(
      map((result: IServiceResponse) => {
        return result.report.map(t => this.mapPartyDocumentFromService(t));
      })
    );
  }

  /**
   * Получить документ из пати
   * @param party
   * @param documentType
   */
  // getPartyDocumentByType(party:IParty, documentType: TPartyDocumentType):IPartyDocument {
  //   if (!party) return JSON.parse(JSON.stringify(emptyPartyDocument));
  //   if (!party.documents || !Array.isArray(party.documents)) return JSON.parse(JSON.stringify(emptyPartyDocument));
  //   const result = party.documents.find(t=>t.type === documentType);
  //   return result?result:JSON.parse(JSON.stringify(emptyPartyDocument));
  // }
  mapPartyDocumentFromService(item: object): IPartyDocument {
    const result: IPartyDocument = {
      ...JSON.parse(JSON.stringify(emptyPartyDocument)),
      id: item['id'],
      type: item['type_code'],
      partyId: item['party_id'],
      status: item['status_code'],
      name: item['name'],
      description: item['description'],
      profile: item['profile'],
      profileDocumentType: item['profile_document_type'],
      photos: []
    };
    return result;
  }
}
